export default __webpack_public_path__ + "0d5cdfbf3a8d12039d0a1731c7d6a81d.svg";